
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import api from "@/services/api.service";
import { FeaturesList } from "@/store/types";
import vselect3 from "vselect3";

import { isEqual } from "lodash";
import { getLandingPages, RouteConfigX, findRouteByKey } from '@/router';

@Component({
	components: {
		vselect3
	}
})
export default class AccountDetails extends Vue {
	@Getter("getFeaturesList") featuresList: FeaturesList;
	@Getter getFeature: (featureName: string[]) => boolean;

    private currentSelectedLandingPage: RouteConfigX | null = null;

	private selectedLandingPage: RouteConfigX | null = null;

    private loadingUserSettings: boolean = false;

    private errorMessage: string = "";

    private async mounted(): Promise<void> {
        this.loadingUserSettings = true;

        try {
            await this.getUserSettings();
        } finally {
            this.loadingUserSettings = false;
        }

        if (this.selectedLandingPage && !this.landingPages.map(x => x.meta?.key).includes(this.selectedLandingPage.meta?.key)) {
            this.currentSelectedLandingPage = null;
            this.selectedLandingPage = null;
            await this.saveUserSettings();
            this.errorMessage = "Landing page has been removed due to inefficient permissions";
            setTimeout(() => {
                this.errorMessage = "";
            }, 2500);
        }
    }

    private async getUserSettings(): Promise<void> {
        await this.getLandingPage();
    }

    private async getLandingPage(): Promise<void> {
        const { data } = await api.getLandingPageForUser();
        if (!data) {
            this.selectedLandingPage = null;
            this.currentSelectedLandingPage = null;
            return;
        }
        const route = findRouteByKey(data);

        this.selectedLandingPage = route ?? null;
        this.currentSelectedLandingPage = route ?? null;
    }

    private get landingPages(): RouteConfigX[] {
        return getLandingPages(true);
    }

    private cancelChangedUserSettings() {
        this.currentSelectedLandingPage = this.selectedLandingPage;
    }

    private async saveUserSettings(): Promise<void> {
        await api.setLandingPage(this.currentSelectedLandingPage?.meta?.key ?? "");
        this.selectedLandingPage = this.currentSelectedLandingPage;
    }

    private get landingPageChanged(): boolean {
        return !isEqual(this.currentSelectedLandingPage, this.selectedLandingPage);
    }
}
